export const CATEGORY_QUERY_PARAM_KEY = "categories";
export const BRAND_QUERY_PARAM_KEY = "brands";
export const DISCOUNT_QUERY_PARAM_KEY = "discount";
export const PRICE_QUERY_PARAM_KEY = "priceRange";
export const ORDER_SEARCH = "search";
